import { useEffect, useState } from "react"

export default function Padding({
    h = undefined,
    v = undefined,
    top = 'inherit',
    left = 'inherit',
    right = 'inherit',
    bottom = 'inherit',
    children
}) {
    const [paddingStyle, setPaddingStyle] = useState(undefined)
    
    useEffect(() => {   
        if (h || v) {
            setPaddingStyle({
                padding: `${v} ${h}`
            })
        } else {
            setPaddingStyle({
                paddingLeft: `${left}`,
                paddingRight: `${right}`,
                paddingTop: `${top}`,
                paddingBottom: `${bottom}`,
            })
        }
    }, [])

    return (
        <div className="padding" style={paddingStyle}>
            {children}
        </div>
    )
}
